import AddTask from './AddTask'

export { AddTask } from './AddTask'
export default AddTask;


// WEBPACK FOOTER //
// ./src/components/AddTask/index.js